import getT from "../getT";

export default function (material){

    return `
    <div class="h6 mb-3">${getT("Материал")}: [${material?.id}] ${material?.name}</div>
    `
}